<template>
  <Drawer
    width="400"
    :title="newDepartment ? '新增' : '编辑' + '部门'"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <span v-if="selectedParentDepartment"
        >{{ openedDepartment.name }}将添加在
        {{ selectedParentDepartment.name || "全部" }} 下</span
      >
      <span v-else>请选择新部门将要添加的位置</span>
      <div class="tree-wrapper">
        <Tree :data="treeDepartmentData" :render="renderContent"></Tree>
      </div>
      <Form
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="部门名字" prop="name">
          <Input v-model="formItem.name" placeholder="输入名字..." />
        </FormItem>
        <FormItem label="类型" prop="type">
          <CheckboxGroup v-model="formItem.type">
            <Checkbox label="sales">销售</Checkbox>
            <Checkbox label="tech">技术</Checkbox>
          </CheckboxGroup>
        </FormItem>
         <FormItem label="是否禁用">
          <i-switch v-model="formItem.banned" size="large" true-color="#ff4949">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "editDepartmentDrawer",
  props: [],
  data() {
    return {
      drawerOpened: false,
      treeDepartmentData: [],
      newDepartment: false,
      openedDepartment: null,
      selectedParentDepartment: null,
      formItem: {
        name: "新部门",
        type: [],
        banned: false,
      },
      ruleValidate: {
        name: [{ required: true, message: "名字为必填项", trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapActions({
      createDepartment: "department/createDepartmentAction",
      updateDepartment: "department/updateDepartmentAction",
    }),
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.newDepartment) {
              // create
              await this.createDepartment({
                name: this.formItem.name,
                parent:
                  this.selectedParentDepartment &&
                  this.selectedParentDepartment._id
                    ? this.selectedParentDepartment._id
                    : null,
                type: {
                  sales: this.formItem.type.includes("sales"),
                  tech: this.formItem.type.includes("tech"),
                },
                banned: this.formItem.banned
              });
            } else {
              // update
              await this.updateDepartment({
                id: this.openedDepartment._id,
                data: {
                  name: this.formItem.name,
                  parent:
                    this.selectedParentDepartment &&
                    this.selectedParentDepartment._id
                      ? this.selectedParentDepartment._id
                      : null,
                  type: {
                    sales: this.formItem.type.includes("sales"),
                    tech: this.formItem.type.includes("tech"),
                  },
                  banned: this.formItem.banned
                },
              });
            }
            this.drawerOpened = false;
            this.$Message.success("保存成功!");
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    openDrawer(data, treeDepartmentData) {
      Object.assign(this.$data, this.$options.data());
      this.drawerOpened = true;
      this.treeDepartmentData = this.getTreeDepartment(false, [
        data && data._id,
      ]);
      if (!data) {
        // 新增部门
        this.newDepartment = true;
        this.openedDepartment = {
          _id: "0",
          name: this.formItem.name,
          title: this.formItem.name,
        };
        this.treeDepartmentData[0].children.push(this.openedDepartment);
      } else {
        // 修改部门
        this.openedDepartment = data;
        this.formItem.name = data.name;
        if (data.type.sales) this.formItem.type.push("sales");
        if (data.type.tech) this.formItem.type.push("tech");
        this.selectedParentDepartment = this.getDepartmentById(data.parent);
      }
    },
    renderContent(h, { root, node, data }) {
      let button;
      let textStyle = {
        style: {
          display: "flex",
          width: "100%",
          alignItems: "center",
        },
      };
      if (!this.isChildNode(node.node._id, this.openedDepartment)) {
        button = h(
          "span",
          {
            style: {
              display: "inline-block",
              float: "right",
              marginLeft: "10px",
            },
          },
          [
            h("Button", {
              props: Object.assign({}, this.buttonProps, {
                icon: "ios-add",
              }),
              style: {
                padding: "0 4px",
                height: "24px"
              },
              on: {
                click: () => {
                  this.append(root, data);
                },
              },
            }),
          ]
        );
      } else {
        textStyle = {
          style: {
            display: "inline-block",
            width: "100%",
            color: "blue",
            fontWeight: "500",
          },
        };
      }

      const content = h("span", textStyle, [h("span", data.title), button]);

      return content;
    },
    append(root, data) {
      this.selectedParentDepartment = data;
      this.treeDepartmentData = this.filterData(
        this.treeDepartmentData,
        this.openedDepartment._id
      );

      const children = data.children || [];
      children.push({
        ...this.openedDepartment,
        expand: true,
      });
      this.$set(data, "children", children);
    },
    filterData(data, _id) {
      return data.filter((o) => {
        if (o.children) o.children = this.filterData(o.children, _id);
        return o._id != _id;
      });
    },
    isChildNode(nodeId, parentNode) {
      if (nodeId === parentNode._id) {
        return true;
      } else {
        if (!parentNode.children || parentNode.children.length === 0)
          return false;
        for (let i = 0; i < parentNode.children.length; i++) {
          let b = this.isChildNode(nodeId, parentNode.children[i]);
          if (b) return true;
        }
        return false;
      }
    },
  },
  computed: {
    ...mapGetters({
      getDepartmentById: "department/getDepartmentById",
      getTreeDepartment: "department/getTreeDepartment",
    }),
  },
};
</script>

<style scoped lang="stylus">
.drawer-content
  overflow-y auto

.tree-wrapper
  border lightgrey solid 1px
  border-radius 4px
  padding 8px
  margin-top 8px
  margin-bottom 24px
</style>
